import { SeriesOfFund } from 'model/series';
import { action } from 'typesafe-actions';
import { GiroWebappError } from '../../../model/error';
import { SharePerformanceActionTypes } from './types';

export const sharePerformanceRequest = (seriesId: string) => action(SharePerformanceActionTypes.SHARE_PERFORMANCE_REQUEST, seriesId);
export const sharePerformanceSuccess = (response: SeriesOfFund[]) => action(SharePerformanceActionTypes.SHARE_PERFORMANCE_SUCCESS, response);
export const sharePerformanceError = (error: GiroWebappError) => action(SharePerformanceActionTypes.SHARE_PERFORMANCE_ERROR, error);
export const sharePerformanceResetState = () => action(SharePerformanceActionTypes.SHARE_PERFORMANCE_RESET_STATE);
